<mat-expansion-panel [expanded]="true">
	<main>
		<section>
			<span id="mass-inclusion" class="action-group">
				<mat-icon color="accent" class="icon">cloud_upload</mat-icon>
				<span class="icon-labeled">
					<span class="label">Inclusão em massa:</span>
				</span>
				<button
					mat-button
					color="primary"
					(click)="onFileDownload(actionType.INCLUSION)"
					class="download-button"
				>
					<mat-icon svgIcon="sanus-download"></mat-icon>
					<span>Baixar Modelo</span>
				</button>
				<span class="import-file">
					<label class="button import-file-label" for="inputInclusion">
						<mat-icon svgIcon="sanus-upload"></mat-icon>
						<p class="import-file-text">Importar Arquivo</p>
					</label>
					<input
						#fileInputInclusion
						class="file-input"
						type="file"
						id="inputInclusion"
						[multiple]="false"
						(change)="onFileUpload(actionType.INCLUSION, $event)"
					/>
				</span>
			</span>
		</section>

		<section>
			<span id="mass-update" class="action-group">
				<mat-icon [ngStyle]="{ color: 'orange' }">update</mat-icon>
				<span class="icon-labeled">
					<span class="label">Atualização em massa:</span>
				</span>
				<button
					mat-button
					color="primary"
					(click)="onFileDownload(actionType.UPDATE)"
					class="download-button"
				>
					<mat-icon svgIcon="sanus-download"></mat-icon>
					<span>Baixar Modelo</span>
				</button>
				<span class="import-file">
					<label class="button import-file-label" for="inputUpdate">
						<mat-icon svgIcon="sanus-upload"></mat-icon>
						<p class="import-file-text">Importar Arquivo</p>
					</label>
					<input
						#fileInputUpdate
						class="file-input"
						type="file"
						id="inputUpdate"
						[multiple]="false"
						(change)="onFileUpload(actionType.UPDATE, $event)"
					/>
				</span>
			</span>
		</section>
		<section>
			<span id="mass-transfer" class="action-group">
				<mat-icon [ngStyle]="{ color: 'dodgerblue' }">swap_horiz</mat-icon>
				<span class="icon-labeled">
					<span class="label">Transferência em massa:</span>
				</span>
				<button
					mat-button
					color="primary"
					(click)="onFileDownload(actionType.TRANSFER)"
					class="download-button"
				>
					<mat-icon svgIcon="sanus-download"></mat-icon>
					<span>Baixar Modelo</span>
				</button>
				<span class="import-file">
					<label class="button import-file-label" for="inputTransfer">
						<mat-icon svgIcon="sanus-upload"></mat-icon>
						<p class="import-file-text">Importar Arquivo</p>
					</label>
					<input
						#fileInputTransfer
						class="file-input"
						type="file"
						id="inputTransfer"
						[multiple]="false"
						(change)="onFileUpload(actionType.TRANSFER, $event)"
					/>
				</span>
			</span>
		</section>

		<section>
			<span id="mass-exclusion" class="action-group">
				<mat-icon color="warn">delete_forever</mat-icon>
				<span class="icon-labeled">
					<span class="label">Exclusão em massa:</span>
				</span>
				<button
					mat-button
					color="primary"
					(click)="onFileDownload(actionType.EXCLUSION)"
					class="download-button"
				>
					<mat-icon svgIcon="sanus-download"></mat-icon>
					<span>Baixar Modelo</span>
				</button>
				<span class="import-file">
					<label class="button import-file-label" for="inputExclusion">
						<mat-icon svgIcon="sanus-upload"></mat-icon>
						<p class="import-file-text">Importar Arquivo</p>
					</label>
					<input
						#fileInputExclusion
						class="file-input"
						type="file"
						id="inputExclusion"
						[multiple]="false"
						(change)="onFileUpload(actionType.EXCLUSION, $event)"
					/>
				</span>
			</span>
		</section>

		<section>
			<span id="download-report" class="action-group">
				<mat-icon>list_alt</mat-icon>
				<span class="icon-labeled">
					<span class="label">Beneficiários ativos:</span>
				</span>
				<button
					mat-button
					color="primary"
					(click)="onActiveDataDownload()"
					class="download-button"
				>
					<mat-icon svgIcon="sanus-download"></mat-icon>
					<span>Baixar Relatório</span>
				</button>
			</span>
		</section>

		<section>
			<span id="download-report" class="action-group">
				<mat-icon [ngStyle]="{ color: 'grey' }">list_alt</mat-icon>
				<span class="icon-labeled">
					<span class="label">Beneficiários inativos:</span>
				</span>
				<button
					mat-button
					color="primary"
					(click)="onInactiveDataDownload()"
					class="download-button"
				>
					<mat-icon svgIcon="sanus-download"></mat-icon>
					<span>Baixar Relatório</span>
				</button>
			</span>
		</section>

		<section>
			<ng-container *ngIf="isMatriz">
				<span id="download-group-report">
					<mat-icon>library_books</mat-icon>
					<span class="icon-labeled">
						<span class="label">Relatório de ativos do grupo:</span>
					</span>
					<button
						mat-button
						color="primary"
						(click)="onActiveDataDownload(true)"
						class="download-button"
					>
						<mat-icon svgIcon="sanus-download"></mat-icon>
						<span>Baixar Relatório</span>
					</button>
				</span>
			</ng-container>
		</section>

		<section>
			<ng-container *ngIf="isMatriz">
				<span id="download-group-report">
					<mat-icon [ngStyle]="{ color: 'grey' }">library_books</mat-icon>
					<span class="icon-labeled">
						<span class="label">Relatório de inativos do grupo:</span>
					</span>
					<button
						mat-button
						color="primary"
						(click)="onInactiveDataDownload(true)"
						class="download-button"
					>
						<mat-icon svgIcon="sanus-download"></mat-icon>
						<span>Baixar Relatório</span>
					</button>
				</span>
			</ng-container>
		</section>
	</main>
</mat-expansion-panel>
